<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-exclamation-triangle fa-lg icon-button"
                title="Visualizar Mensagem de Erro de Integração"
                @click.stop="exibirMensagem()"
            ></i>
        </span>
    </div>
</template>

<script>

export default {
    props: {
        mensagemErro: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        exibirMensagem() {
            this.$swal({
                title: 'Erro de Integração',
                html: `${this.mensagemErro}`,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
                width: 800,
            })
        },
    },
}
</script>

<style>
    .swal2-html-container {
        max-height: 200px;
        overflow-y: auto;
        padding-right: 10px;
    }
</style>